export const hero = () => {
    const video = document.querySelector<HTMLVideoElement>('.hero-banner__video video');
    const controls = document.querySelector<HTMLButtonElement>('.hero-banner__video .play-pause-button');

    if (!video || !controls)
        return;

    const syncControls = () => {
        controls.classList.toggle('play-pause-button--paused', video.paused);
        controls.setAttribute('aria-label', `${video.paused ? 'Play' : 'Pause'} ${controls.dataset.mediaLabel}`);
    };

    video.addEventListener('play', syncControls);
    video.addEventListener('pause', syncControls);
    video.play().catch(syncControls);

    controls.addEventListener('click', () => {
        if (video.paused) video.play().catch(syncControls); else video.pause();
    });
}
